<template>
    <div style="padding:20px;">
        <div style="margin-bottom:20px;display:flex;justify-content:space-between" class="order-header">
            <a-button type="primary" @click="createOrder">新建PI</a-button> 
            <div>
            <span>筛选：</span>
            <a-select  style="width: 120px" @change="handleTypeChange" v-model="selectedType" placeholder="筛选PI类型" allowClear>
                <a-select-option value="">
                    筛选PI类型
                </a-select-option>
                <a-select-option value="1">
                    境外单
                </a-select-option>
                <a-select-option value="2">
                    境内单
                </a-select-option>
            </a-select>
            <a-select  style="width: 120px" @change="handleStatusChange" v-model="selectedStatus" placeholder="筛选PI类型" allowClear>
                <a-select-option value="">
                    筛选PI状态
                </a-select-option>
                <a-select-option value="1">
                    未结单
                </a-select-option>
                <a-select-option value="2">
                    已结单
                </a-select-option>
            </a-select>
            <a-select default-value="lucy" style="width: 150px" @change="handleCountryChange" v-model="selectedCountry" placeholder="筛选国家地区" allowClear>
                <a-select-option value="">
                    筛选国家地区
                </a-select-option>
                <a-select-option :value="c.code" v-for="(c,index) in config.countries" :key="index">
                    {{ c.name }} ({{ c.code }})
                </a-select-option>
            </a-select>
            <a-input placeholder="输入客户名以搜索" style="width:150px" :allowClear="true" @change="handleCustomerChange" v-model="selectedCustomer"/>
            <a-input placeholder="输入货代名以搜索" style="width:150px" :allowClear="true" @change="handleFreightChange" v-model="selectedFreight"/>
            <a-input placeholder="输入产品名以搜索" style="width:150px" :allowClear="true" @change="handleProductNameChange" v-model="selectedProductName"/>
            <a-input placeholder="输入PINo.以搜索" style="width:150px" :allowClear="true" @change="handlePINoChange" v-model="selectedPINo"/>
            <!-- <a-range-picker @change="onETDChange" :placeholder="['提单日起', '提单日止']" style="width:250px" v-model="selectedETD"/>
            <a-range-picker @change="onETAChange" :placeholder="['到港日起', '到港日止']" style="width:250px" v-model="selectedETA"/> -->
            <a-button type="primary" @click="resetFilter" style="margin-left:10px">重置筛选条件</a-button> 

            <a-button type="primary" @click="exportData" style="margin-left:10px" v-show="admin">导出</a-button> 
        </div>
        </div>
    <a-table :columns="columns" :data-source="data" size="middle" :pagination="false">
      <span slot="type" slot-scope="type">
        <a-tag v-if="type == 1"
          color="orange">
          境外单
        </a-tag>
        <a-tag v-if="type == 2"
          color="geekblue">
          境内单
        </a-tag>
      </span>
      <span slot="status" slot-scope="status">
        <a-tag v-if="status == 1"
          color="red">
          未结单
        </a-tag>
        <a-tag v-if="status == 2"
          color="green">
          已结单
        </a-tag>
      </span>
      <span slot="region" slot-scope="region">
        <span v-if="config.countries">{{config.countries.find(t=>t.code == region).name}} </span> ({{region}})
      </span>
      <span slot="firstProduct" slot-scope="text, record">
        <span v-if="record.products && record.products.length > 0">{{ record.products[0].productName }} </span> 
      </span>

      <span slot="firstProductCount" slot-scope="text, record">
        <span v-if="record.products && record.products.length > 0">{{ record.products[0].productCount }} </span>
      </span>

      <span slot="dollarProfitTotal" slot-scope="text, record">
        <span v-if="record.type ==1">{{ record.profitTotal}} </span>
        <span v-if="record.type ==2"> </span>
      </span>

      <span slot="profitTotal" slot-scope="text, record">
        <span v-if="record.type ==1">{{ (record.profitTotal * 7.1).toFixed(2)}} </span>
        <span v-if="record.type ==2 ">{{ parseFloat(record.profitTotal).toFixed(2)}} </span>
      </span>
      <span slot="action" slot-scope="text, record">
        <a href="#" @click="edit(record)">编辑</a>
        <a-divider type="vertical" />
        <a href="#" @click="deleteOrder(record)">删除</a>
      </span>
    </a-table>

    <div v-if="data.length > 0 && summary!= null" style="margin-top:10px;justify-content: space-between;display: flex;padding:0px 10px;">
                            <div>合计</div>
                            <div style="display: flex;justify-content: space-between;">
                                <div class="total-item">产品: <span class="num">{{summary.totalProductCount.toFixed(2)}}</span></div>
                                <div class="total-item">合同金额: <span class="num">{{summary.totalProductPrice.toFixed(2)}}</span></div>
                                <div class="total-item">实收: <span class="num">{{summary.totalIncome.toFixed(2)}}</span></div>
                                <div class="total-item">采购: <span class="num">{{summary.totalProcument.toFixed(2)}}</span></div>
                                <div class="total-item">物流: <span class="num">{{summary.totalShipping.toFixed(2)}}</span></div>
                                <div class="total-item">佣金: <span class="num">{{summary.totalBrokerage.toFixed(2)}}</span></div>
                                <div class="total-item">其他: <span class="num">{{summary.totalOther.toFixed(2)}}</span></div>
                                <div class="total-item" v-show="admin">利润: <span class="num">{{summary.totalProfit.toFixed(2)}}</span></div>
                                <div class="total-item" v-show="admin">利润率: <span class="num">{{(summary.totalProfitRate * 100).toFixed(2)}}</span></div>
                            </div>
                        </div>
    <div style="margin-top:20px;overflow:hidden">
    <a-pagination v-model="pageNumber" style="float:left;" :show-total="total => `共 ${total} 条`" @change="onPageChange"  :total="total"  show-quick-jumper :pageSize="pageSize" />
        <div style="float:right"> 每页 <a-select default-value="lucy" style="width: 60px;" v-model="pageSize" @change="changePageSize" >
               <a-select-option value="10">
                    10
                </a-select-option>
                <a-select-option value="15">
                    15
                </a-select-option>
                <a-select-option value="20">
                    20
                </a-select-option>
                <a-select-option value="30">
                    30
                </a-select-option>
                <a-select-option value="50">
                    50
                </a-select-option>
            </a-select> 条
        </div>
    </div>
    <a-modal v-model="createModal" :title="mode == 'create'?'创建PI':'编辑PI'" ok-text="保存PI信息" cancel-text="取消" @ok="submitCreateModal" width="1200px">
        <a-row>
            <a-col span="8">
                <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-form-model-item label="合同编号">
                        {{ form.orderPre }} <a-input v-model="form.orderNo" style="width:60px"/> {{ form.orderPost }}
                    </a-form-model-item>
                    <a-form-model-item label="合同类型">
                        <a-radio-group v-model="form.type">
                            <a-radio value="1">
                            境外单
                            </a-radio>
                            <a-radio value="2">
                            境内单
                            </a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="状态">
                        <a-radio-group v-model="form.status">
                            <a-radio value="1">
                            未结单
                            </a-radio>
                            <a-radio value="2">
                            已结单
                            </a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="提单日(ETD)">
                        <a-date-picker
                            v-model="form.etd"
                            type="date"
                            placeholder="选择日期"
                            @change="$forceUpdate()"
                        />
                    </a-form-model-item>
                    <a-form-model-item label="到港日(ETA)">
                        <a-date-picker
                            v-model="form.eta"
                            type="date"
                            placeholder="选择日期"
                            @change="$forceUpdate()"
                        />
                    </a-form-model-item>
                    
                </a-form-model>
            </a-col>
            <a-col span="6">
                <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item label="国家简称">
                        <a-select v-model="form.region" placeholder="选择国家简称">
                            <a-select-option :value="c.code" v-for="(c,index) in config.countries" :key="index">
                            {{ c.name }} ({{ c.code }})
                            </a-select-option>
                        
                        </a-select>
                    </a-form-model-item>


                    <a-form-model-item label="客户名称">
                    <a-input v-model="form.customer" />
                    </a-form-model-item>

                    <a-form-model-item label="销售人员">
                        <a-select v-model="form.sales" placeholder="选择销售人员">
                            <a-select-option :value="sale" v-for="(sale,index) in config.sales" :key="index">
                            {{sale}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="佣金汇总">
                        <a-input-number v-model="form.brokerage" />
                    </a-form-model-item>
                </a-form-model>
            </a-col>
            <a-col span="10">
                <a-table :columns="productColumns" :dataSource="products" size="small" :pagination="false">
                            <template :slot="temp" slot-scope="text, record, index" v-for="temp in productNumberColumns">
                                <div>
                                    <a-input-number
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleProductChange(e, record.key, temp)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp1" slot-scope="text, record, index" v-for="temp1 in productEditableColumns">
                                <div>
                                    <a-input
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleProductChange(e.target.value, record.key, temp1)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="s" slot-scope="text, record, index" v-for="s in productFixedColumns">
                                <div>  
                                    <span> {{ parseFloat(text).toFixed(2) }}</span>
                                </div>
                            </template>
                            <span slot="action" slot-scope="text, record,index">
                                <a href="#" @click="deleteProduct(index)">删除</a>
                                    
                            </span>
                        </a-table>
                        <div v-if="products.length > 0" style="margin-top:10px;justify-content: space-between;display: flex;padding:0px 10px;">
                            <div>合计</div>
                            <div style="display: flex;justify-content: space-between;">
                                <div class="total-item">数量: <span class="num">{{getProductTotal().count}}</span></div>
                                <div class="total-item">总量: <span class="num">{{getProductTotal().total}}</span></div>
                            </div>
                        </div>
                        <a-button type="primary" style="margin-top:10px" @click="addProduct"><a-icon type="plus"/>添加产品</a-button>
            </a-col>
        </a-row>
        
        <a-row style="margin-top:20px;">
            <a-tabs default-active-key="2" tab-position="top" type="card">
                   
                    <a-tab-pane key="2" tab="采购">
                        <a-table :columns="procumentColumns" :dataSource="procuments" size="small" :pagination="false">
                            <template :slot="temp3" slot-scope="text, record, index" v-for="temp3 in procumentNumberColumns">
                                <div>
                                    <a-input-number
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleProcumentChange(e, record.key, temp3)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp4" slot-scope="text, record, index" v-for="temp4 in procumentEditableColumns">
                                <div>
                                    <a-input
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleProcumentChange(e.target.value, record.key, temp4)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp5" slot-scope="text, record, index" v-for="temp5 in procumentFixedColumns">
                                <div>  
                                    <span> {{ parseFloat(text).toFixed(2) }}</span>
                                </div>
                            </template>
                        
                            <span slot="action" slot-scope="text, record">
                                <!-- <a href="#" @click="record.mode = 'edit'" v-if="record.mode == 'normal'">编辑</a><a-divider type="vertical" v-if="record.mode == 'normal'"/> -->
                                <a href="#" @click="deleteProcument(index)">删除</a>
                                <!-- <a href="#" @click="saveProcument(record)" v-if="record.mode == 'edit'">确定</a><a-divider type="vertical" v-if="record.mode == 'edit'"/>
                                <a href="#" @click="record.mode = 'normal'" v-if="record.mode == 'edit'">取消</a> -->
                                
                            </span>
                        </a-table>
                        <div v-if="procuments.length > 0" style="margin-top:10px;justify-content: space-between;display: flex;padding:0px 10px;">
                            <div>合计</div>
                            <div style="display: flex;justify-content: space-between;">
                                <div class="total-item">最终采购成本总量: <span class="num">{{getProcumentTotal().total}}</span></div>
                            </div>
                        </div>
                        <a-button type="primary" style="margin-top:10px" @click="addProcument"><a-icon type="plus"/>添加采购</a-button>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="物流">
                        <a-table :columns="shippingColumns" :dataSource="shippings" size="small" :pagination="false">
                            <template :slot="temp6" slot-scope="text, record, index" v-for="temp6 in shippingNumberColumns">
                                <div>
                                    <a-input-number
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    style="width:70px"
                                    @change="e => handleShippingChange(e, record.key, temp6)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp7" slot-scope="text, record, index" v-for="temp7 in shippingEditableColumns">
                                <div>
                                    <a-input
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleShippingChange(e.target.value, record.key, temp7)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp8" slot-scope="text, record, index" v-for="temp8 in shippingFixedColumns">
                                <div>  
                                    <span> {{ parseFloat(text).toFixed(2) }}</span>
                                </div>
                            </template>
                            <span slot="action" slot-scope="text, record">
                                <!-- <a href="#" @click="record.mode = 'edit'" v-if="record.mode == 'normal'">编辑</a><a-divider type="vertical" v-if="record.mode == 'normal'"/> -->
                                <a href="#" @click="deleteShipping(index)">删除</a>
                                <!-- <a href="#" @click="saveShipping(record)" v-if="record.mode == 'edit'">确定</a><a-divider type="vertical" v-if="record.mode == 'edit'"/>
                                <a href="#" @click="record.mode = 'normal'" v-if="record.mode == 'edit'">取消</a> -->
                                
                            </span>
                        </a-table>
                        <div v-if="shippings.length > 0" style="margin-top:10px;justify-content: space-between;display: flex;padding:0px 10px;">
                            <div>合计</div>
                            <div style="display: flex;justify-content: space-between;">
                                <div class="total-item">最终物流总量: <span class="num">{{getShippingTotal().total}}</span></div>
                            </div>
                        </div>
                        <a-button type="primary" style="margin-top:10px" @click="addShipping"><a-icon type="plus"/>添加物流</a-button>
                    </a-tab-pane>
                    <a-tab-pane key="4" tab="银行费用">
                        <a-table :columns="bankCostColumns" :dataSource="bankcosts" size="small" :pagination="false">
                            <template :slot="temp10" slot-scope="text, record, index" v-for="temp10 in bankcostNumberColumns">
                                <div>
                                    <a-input-number
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleBankcostChange(e, record.key, temp10)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp11" slot-scope="text, record, index" v-for="temp11 in bankcostEditableColumns">
                                <div>
                                    <a-input
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleBankcostChange(e.target.value, record.key, temp11)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp12" slot-scope="text, record, index" v-for="temp12 in bankcostFixedColumns">
                                <div>  
                                    <span> {{ parseFloat(text).toFixed(2) }}</span>
                                </div>
                            </template>
                            <template slot="actualIncomeDate" slot-scope="text, record, index">
                             
                                <a-date-picker
                                    :value="record.actualIncomeDate"
                                    type="date"
                                    v-if="record.mode == 'edit'"
                                    placeholder="选择日期"
                                    @change="e => handleDateChange(e,record.key)"
                                />
                                <span v-else>{{  record.actualIncomeDate.format('yyyy-MM-DD') }}</span>
                            </template>
                            <span slot="action" slot-scope="text, record">
                                <!-- <a href="#" @click="record.mode = 'edit'" v-if="record.mode == 'normal'">编辑</a><a-divider type="vertical" v-if="record.mode == 'normal'"/> -->
                                <a href="#" @click="deleteBankcost(index)" >删除</a>
                                <!-- <a href="#" @click="saveBankcost(record)" v-if="record.mode == 'edit'">确定</a><a-divider type="vertical" v-if="record.mode == 'edit'"/>
                                <a href="#" @click="record.mode = 'normal'" v-if="record.mode == 'edit'">取消</a> -->
                                
                            </span>
                        </a-table>
                        <div v-if="bankcosts.length > 0" style="margin-top:10px;justify-content: space-between;display: flex;padding:0px 10px;">
                            <div>合计</div>
                            <div style="display: flex;justify-content: space-between;">
                                <div class="total-item">最终实收总量: <span class="num">{{getBankTotal().total}}</span></div>
                            </div>
                        </div>
                        <a-button type="primary" style="margin-top:10px" @click="addBankcost"><a-icon type="plus"/>添加银行费用</a-button>
                    </a-tab-pane>

                    <a-tab-pane key="5" tab="其他费用">
                        <a-table :columns="otherColumns" :dataSource="others" size="small" :pagination="false">
                            <template :slot="temp13" slot-scope="text, record, index" v-for="temp13 in otherNumberColumns">
                                <div>
                                    <a-input-number
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleOtherChange(e, record.key, temp13)"/>
                                    <span v-else> {{ text }}</span>  
                                </div>
                            </template>
                            <template :slot="temp14" slot-scope="text, record, index" v-for="temp14 in otherEditableColumns">
                                <div>
                                    <a-input
                                    v-if="record.mode == 'edit'"
                                    :value="text"
                                    @change="e => handleOtherChange(e.target.value, record.key, temp14)"/>
                                    <span v-else> {{ text }}</span>
                                </div>
                            </template>
                            <template :slot="temp15" slot-scope="text, record, index" v-for="temp15 in otherFixedColumns">
                                <div>  
                                    <span> {{ parseFloat(text).toFixed(2) }}</span>
                                </div>
                            </template>
                           
                            <span slot="action" slot-scope="text, record">
                                 <a href="#" @click="deleteOther(index)" >删除</a>
                              
                            </span>
                        </a-table>
                        <div v-if="others.length > 0" style="margin-top:10px;justify-content: space-between;display: flex;padding:0px 10px;">
                            <div>合计</div>
                            <div style="display: flex;justify-content: space-between;">
                                <div class="total-item">其他费用总量: <span class="num">{{getOtherTotal().total}}</span></div>
                            </div>
                        </div>
                        <a-button type="primary" style="margin-top:10px" @click="addOther"><a-icon type="plus"/>添加其他费用</a-button>
                    </a-tab-pane>
                </a-tabs>
        </a-row>
       
    </a-modal>
</div>
  </template>
  <script>
  import config from '../../util/config';
  import moment from 'moment';

  const columns = [
    {
      dataIndex: 'contractNo',
      key: 'contractNo',
      title:'PI No.',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      scopedSlots: { customRender: 'type' },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '提单日',
      dataIndex: 'etd',
      key: 'etd',
    },
    {
      title: '到港日',
      key: 'eta',
      dataIndex: 'eta',
    },
    {
      title: '国家',
      key: 'region',
      dataIndex:'region',
      scopedSlots: { customRender: 'region' },
    },
    {
      title: '客户名称',
      key: 'customer',
      dataIndex:'customer'
    },
    {
      title: '销售员',
      key: 'sales',
      dataIndex:'sales'
    },
    {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
  {
    title: '品名',
    key: 'firstProduct',
    scopedSlots: { customRender: 'firstProduct' },
  },
  {
    title: '数量',
    key: 'firstProductCount',
    scopedSlots: { customRender: 'firstProductCount' },
  },
    {
      title: '合同金额',
      key: 'productPrice',
      dataIndex:'productPrice'
    },
    {
      title: '实收',
      key: 'income',
      dataIndex:'income'
    },
    {
      title: '采购汇总',
      key: 'procumentTotal',
      dataIndex:'procumentTotal'
    },
    {
      title: '物流汇总',
      key: 'shippingTotal',
      dataIndex:'shippingTotal'
    },
    // {
    //   title: '银行汇总',
    //   key: 'brokerageTotal',
    //   dataIndex:'brokerageTotal'
    // },
    {
      title: '佣金汇总',
      key: 'extraTotal',
      dataIndex:'extraTotal'
    },
    {
      title: '其他汇总',
      key: 'otherTotal',
      dataIndex:'otherTotal'
    },
    /*
    {
      title: '利润',
      key: 'profitTotal',
      dataIndex:'profitTotal'
    },
    {
      title: '利润比(%)',
      key: 'profitRate',
      dataIndex:'profitRate'
    },*/
    
  ];

  const otherColumns = [
    {
      title: '费用说明',
      key: 'feeTitle',
      dataIndex:'feeTitle',
      scopedSlots: { customRender: 'feeTitle' },
    },
    {
      title: '费用金额',
      key: 'fee',
      dataIndex:'fee',
      scopedSlots: { customRender: 'fee' },
    },
    {
      title: '操作',
      key: 'actions',
      scopedSlots: { customRender: 'action' },
    }
  ]

  const productColumns = [
    {
      title: '产品名',
      key: 'productName',
      dataIndex:'productName',
      scopedSlots: { customRender: 'productName' },
    },
    {
      title: '单价',
      key: 'productPrice',
      dataIndex:'productPrice',
      scopedSlots: { customRender: 'productPrice' },
    },
    
    {
      title: '数量',
      key: 'productCount',
      dataIndex:'productCount',
      scopedSlots: { customRender: 'productCount' },
    },
    {
      title: '总量',
      key: 'productTotal',
      dataIndex:'productTotal',
      scopedSlots: { customRender: 'productTotal' },
    },
    {
      title: '操作',
      key: 'actions',
      scopedSlots: { customRender: 'action' },
    }
  ]

  const procumentColumns = [
     {
      title: '产品名',
      key: 'productName',
      dataIndex:'productName',
      scopedSlots: { customRender: 'productName' },
    },
    {
      title: '数量',
      key: 'productCount',
      dataIndex:'productCount',
      scopedSlots: { customRender: 'productCount' },
    },
    {
      title: '采购单价',
      key: 'procumentPrice',
      dataIndex:'procumentPrice',
      scopedSlots: { customRender: 'procumentPrice' },
    },
    {
      title: '采购总价',
      key: 'procumentTotal',
      dataIndex:'procumentTotal',
      scopedSlots: { customRender: 'procumentTotal' },
    },
    {
      title: '供应商',
      key: 'supplier',
      dataIndex:'supplier',
      scopedSlots: { customRender: 'supplier' },
    },
    {
      title: '去票比率',
      key: 'procumentRatio',
      dataIndex:'procumentRatio',
      scopedSlots: { customRender: 'procumentRatio' },
    },
    {
      title: '去票价',
      key: 'procumentAfterPiao',
      dataIndex:'procumentAfterPiao',
      scopedSlots: { customRender: 'procumentAfterPiao' },
    },
    
    // {
    //   title: '退税',
    //   key: 'procumentRefund',
    //   dataIndex:'procumentRefund',
    //   scopedSlots: { customRender: 'procumentRefund' },
    // },
    {
      title: '最终采购成本',
      key: 'procumentTotalCost',
      dataIndex:'procumentTotalCost',
      scopedSlots: { customRender: 'procumentTotalCost' },
    },
    {
      title: '操作',
      key: 'actions',
      scopedSlots: { customRender: 'action' },
    }
  ]

  const shippingColumns = [
    {
      title: '货代名称',
      key: 'freight',
      dataIndex:'freight',
      scopedSlots: { customRender: 'freight' },
    },
    {
      title: '柜子数量',
      key: 'boxCount',
      dataIndex:'boxCount',
      scopedSlots: { customRender: 'boxCount' },
    },
    {
      title: '柜子单价',
      key: 'boxPrice',
      dataIndex:'boxPrice',
      scopedSlots: { customRender: 'boxPrice' },
    },
    {
      title: '柜子总价',
      key: 'boxTotal',
      dataIndex:'boxTotal',
      scopedSlots: { customRender: 'boxTotal' },
    },
    {
      title: '汇率',
      key: 'rate',
      dataIndex:'rate',
      scopedSlots: { customRender: 'rate' },
    },
    {
      title: '柜子总价（RMB）',
      key: 'boxTotalRMB',
      dataIndex:'boxTotalRMB',
      scopedSlots: { customRender: 'boxTotalRMB' },
    },
    {
      title: '港杂',
      key: 'portCharge',
      dataIndex:'portCharge',
      scopedSlots: { customRender: 'portCharge' },
    },
    {
      title: '货代总费用',
      key: 'freightTotal',
      dataIndex:'freightTotal',
      scopedSlots: { customRender: 'freightTotal' },
    },
    {
      title: '物流费用',
      key: 'innerShippingFee',
      dataIndex:'innerShippingFee',
      scopedSlots: { customRender: 'innerShippingFee' },
    },
    
    {
      title: '打托费',
      key: 'tollFee',
      dataIndex:'tollFee',
      scopedSlots: { customRender: 'tollFee' },
    },
    {
      title: '保险',
      key: 'insurance',
      dataIndex:'insurance',
      scopedSlots: { customRender: 'insurance' },
    },
    {
      title: 'DHL费用',
      key: 'dhl',
      dataIndex:'dhl',
      scopedSlots: { customRender: 'dhl' },
    },
    {
      title: '其他费用',
      key: 'other',
      dataIndex:'other',
      scopedSlots: { customRender: 'other' },
    },
    {
      title: '最终费用',
      key: 'finalShippingCost',
      dataIndex:'finalShippingCost',
      scopedSlots: { customRender: 'finalShippingCost' },
    },
    {
      title: '操作',
      key: 'actions',
      scopedSlots: { customRender: 'action' },
    }
  ]

  const bankCostColumns = [
    {
      title: '实收',
      key: 'actualIncome',
      dataIndex:'actualIncome',
      scopedSlots: { customRender: 'actualIncome' },
    },
    {
      title: '实收日期',
      key: 'actualIncomeDate',
      dataIndex:'actualIncomeDate',
      scopedSlots: { customRender: 'actualIncomeDate' },
    },
    {
      title: '银行费用（外）',
      key: 'bankFee',
      dataIndex:'bankFee',
      scopedSlots: { customRender: 'bankFee' },
    },
    {
      title: '汇率',
      key: 'rate',
      dataIndex:'rate',
      scopedSlots: { customRender: 'rate' },
    },
    {
      title: '实收人民币',
      key: 'actualIncomeRMB',
      dataIndex:'actualIncomeRMB',
      scopedSlots: { customRender: 'actualIncomeRMB' },
    },
    {
      title: '银行费用（RMB）',
      key: 'bankFeeRMB',
      dataIndex:'bankFeeRMB',
      scopedSlots: { customRender: 'bankFeeRMB' },
    },
    {
      title: '收款行',
      key: 'bankName',
      dataIndex:'bankName',
      scopedSlots: { customRender: 'bankName' },
    },
    {
      title: '最终实收',
      key: 'finalIncome',
      dataIndex:'finalIncome',
      scopedSlots: { customRender: 'finalIncome' },
    },
    {
      title: '操作',
      key: 'actions',
      scopedSlots: { customRender: 'action' },
    }
  ]

  export default {
    data() {
      return {
        total:0,
        pageNumber:1,
        pageSize:10,
        selectedType:'',
        selectedCountry:'',
        selectedCustomer:'',
        selectedFreight:'',
        selectedProductName:'',
        selectedStatus:'',
        selectedPINo:'',
        selectedETD:[],
        selectedETA:[],
        productEditableColumns:['productName'],
        productNumberColumns:['productPrice','productCount'],
        productFixedColumns:['productTotal'],
        procumentEditableColumns:['productName','supplier'],
        procumentFixedColumns:['procumentTotal','procumentRefund','procumentTotalCost','procumentAfterPiao'],
        procumentNumberColumns:['productCount','procumentRatio','procumentPrice'],
        shippingEditableColumns:['freight'],
        shippingFixedColumns:['boxTotal','boxTotalRMB','prodcumentTotalCost','finalShippingCost','freightTotal'],
        shippingNumberColumns:['boxCount','boxPrice','rate','portCharge','innerShippingFee','tollFee','insurance','dhl','other'],
        bankcostEditableColumns:['bankName'],
        bankcostFixedColumns:['actualIncomeRMB','finalIncome','bankFee'],
        bankcostNumberColumns:['actualIncome','rate','bankFeeRMB'],
        otherEditableColumns:['feeTitle'],
        otherFixedColumns:[],
        otherNumberColumns:['fee'],
        order:null,
        mode:'create',
        config:{},
        createModal:false,
        orders:[],
        data:[],
        products:[],
        productSummaries:null,
        procuments:[],
        shippings:[],
        bankcosts:[],
        others:[],
        columns:[],
        otherColumns,
        productColumns,
        procumentColumns,
        shippingColumns,
        bankCostColumns,
        labelCol: { span: 6 },
        wrapperCol: { span: 12 },
        admin:false,
        summary:null,
        form: {
            orderPre:'',
            orderPost:'',
            orderNo:'',
            region:'',
            customer:'',
            sales:'',
            type:'1',
            brokerage:'',
            status:'1'
        },
      };
    },
    mounted(){
        var token = window.localStorage.getItem('token');
        if(token == null){
            this.$router.push('/admin');
            return;
        }

        var role = window.localStorage.getItem('role');

        if(role != null){
            
            if(role == 1){
                // columns.push({
                //     title: '利润',
                //     key: 'profitTotal',
                //     dataIndex:'profitTotal'
                // });
                // columns.push({
                    
                //     title: '利润比(%)',
                //     key: 'profitRate',
                //     dataIndex:'profitRate'
                    
                // })
                this.columns = columns.slice();
                this.columns.push({
                    title: '美金利润',
                    key: 'dollarProfitTotal',
                    dataIndex:'dollarProfitTotal',
                    scopedSlots: { customRender: 'dollarProfitTotal' },
                });
                this.columns.push({
                    title: '利润',
                    key: 'profitTotal',
                    dataIndex:'profitTotal',
                    scopedSlots: { customRender: 'profitTotal' },
                });
                
                this.columns.push({
                    
                    title: '利润比(%)',
                    key: 'profitRate',
                    dataIndex:'profitRate'
                })
                this.admin = true;
            }
            else if(role == 2){
                this.columns = columns;
                
            }
        }
        else{
            this.$router.push('/admin');
            return;
        }
        var pageSize = window.localStorage.getItem('pageSize');
        if(pageSize != null){
            this.pageSize = parseInt(pageSize);
        }
        this.loadOrders();
        this.loadConfig();
    },
    methods:{
        loadConfig(){
            this.$http.get(config.url +'/config').then(res=>{
                this.config = res.data;
            })
        },
        saveProduct(record){
            record.mode = 'normal';
            this.order.products = this.products;
        },
        saveProcument(record){
            record.mode = 'normal';
            this.order.procuments = this.procuments;
        },
        saveShipping(record){
            record.mode = 'normal';
            this.order.shippings = this.shippings;
        },
        saveBankcost(record){
            record.mode = 'normal';
            this.order.bankcosts = this.bankcosts;
        },
        deleteOrder(order){
            var result = confirm("删除后无法恢复，确认吗？");
            if(result){
                var id = order.id;
                this.$http.delete(config.url +'/order/' + id).then( res=>{
                    if(res.data.code == 0){
                        this.$message.success('已删除');
                        this.pageNumber = 1;
                        this.loadOrders();
                    }
                    else{
                        this.$message.error('已删除');
                    }
                })
            }
        },
        getProcumentTotal(){
            if(this.procuments.length == 0){
                return;
            }
            var total = 0;
       
            this.procuments.forEach( p=>{
                
                total += p.procumentTotalCost;
            })

            return {
               // count:count,
                total:total.toFixed(2)
            }

        },
        getProductTotal(){
            if(this.products.length == 0){
                return;
            }

            var count = 0;
            var total = 0;
            this.products.forEach( p=>{
                count += p.productCount;
                total += p.productTotal;
            })
            return {
                count:count,
                total:total.toFixed(2)
            }
        },
        getShippingTotal(){
            if(this.shippings.length == 0){
                return;
            }

            var total = 0;
            this.shippings.forEach( p=>{
                total += p.finalShippingCost;
            })
            return {
                total:total.toFixed(2)
            }
        },
        getBankTotal(){
            if(this.bankcosts.length == 0){
                return;
            }
           
            var total = 0;
            this.bankcosts.forEach( p=>{
                total += p.finalIncome;
            })
            return {
                total:total.toFixed(2)
            }
        },
        getOtherTotal(){
            if(this.others.length == 0){
                return;
            }

            var total = 0;
            this.others.forEach( p=>{
               
                total += p.fee;
            })
            return {
                total:total.toFixed(2)
            }
        },
        
        exportToCSV(rows, filename) {
            // 如果没有传入文件名，则使用默认名称
            if (!filename) filename = new Date().toDateString() + '.csv';

            // 如果没有数据，则不执行导出操作
            if (!rows || !rows.length) {
                console.log('No data to export');
                return;
            }

            // 创建CSV内容
            let csvContent = "data:text/csv;charset=utf-8,";

            // 获取列标题
            let headers = Object.keys(rows[0]);
            csvContent += headers.join(",") + "\r\n";
            var that = this;
            // 添加每一行的数据
            rows.forEach(function(rowArray) {
                let row = headers.map(function(fieldName) {
                    return JSON.stringify(rowArray[fieldName], that.replacer);
                }).join(",");
                csvContent += row + "\r\n";
            });

            // 创建隐藏的下载链接
            let encodedUri = encodeURI(csvContent);
            let link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            // 触发点击事件
            link.click();
        },
        replacer(key, value) {
            if (value instanceof Date) {
                return value.toLocaleString();
            }
            return value;
        },
        exportData(){
            var req = {};
            req.start = 0;
            req.size = 100000;
            this.$http.post(config.url +'/orders',req).then(res=>{
                var rows = [];
                res.data.list.forEach( o=>{
                    var obj = {};
                    obj.PiNo = o.PiNo;
                    obj.contractNo = o.contractNo && o.contractNo != null && o.contractNo != '' ? o.contractNo:o.PiNo;
                    obj.customer = o.customer;
                    obj.sales = o.sales;
                    obj.type = o.type;
                    obj.region = o.region;
                    obj.brokerage = o.brokerage;
                    //obj.id = o.id;
                    //obj.key = o.id;
                    //obj.products = o.products;
                    obj.status = o.status ? o.status:'1';
                    //obj.others = o.others;
                    //obj.shippings = o.shippings;
                    //obj.bankcosts = o.bankcosts;
                    //obj.procuments = o.procuments;
                    obj.procumentTotal = parseFloat(o.procumentTotal).toFixed(2);
                    obj.profitTotal = parseFloat(o.profitTotal).toFixed(2);
                    obj.shippingTotal = o.shippingTotal;
                    obj.profitRate = o.profitRate;
                    obj.extraTotal = o.brokerage;
                    obj.otherTotal = o.otherTotal;
                    obj.income = parseFloat(o.income).toFixed(2);
                    obj.brokerageTotal = parseFloat(o.brokerageTotal).toFixed(2);
                    obj.productPrice = parseFloat(o.productPrice).toFixed(2);
                    
                    if(o.eta && o.eta != ''){
                        //obj.etaObj = o.eta
                        obj.eta = new Date(o.eta).format('MM.dd');
                    }
                    
                    if(o.etd && o.etd != ''){
                        //obj.etdObj = o.etd;
                        obj.etd = new Date(o.etd).format('MM.dd');
                    }

                    rows.push(obj);
                })

                //alert(rows.length);
                this.exportToCSV(rows);
            })
        },
        handleProcumentChange(value,key,column){
            const newData = [...this.procuments];
            const target = newData.find(item => key === item.key);
            if (target) {
                target[column] = value;
                target['procumentTotal'] = target['productCount'] * target['procumentPrice'];
                target['procumentAfterPiao'] = target['procumentPrice'] * (1 - target['procumentRatio']);
                target['procumentTotalCost'] = target['procumentAfterPiao'] * target['productCount'];
                this.procuments = newData;
            }
        },
        onPageChange(page,pageSize){
            this.pageNumber = page;
            this.loadOrders();
        },
        deleteProduct(index){
            this.products.splice(index,1);
        },
        deleteProcument(index){
            this.procuments.splice(index,1);
        },
        deleteShipping(index){
            this.shippings.splice(index,1);
        },
        deleteBankcost(index){
            this.bankcosts.splice(index,1);
        },
        deleteOther(index){
            this.others.splice(index,1);
        },
        getSummary(){
            return {
                total:0,
                count:0
            }
        },
        handleShippingChange(value,key,column){
            const newData = [...this.shippings];
            const target = newData.find(item => key === item.key);
            if (target) {
                target[column] = value;
                target['boxTotal'] = target['boxPrice'] * target['boxCount'];
                target['boxTotalRMB'] = target['boxTotal'] * target['rate'];
                target['freightTotal'] = target['boxTotalRMB'] + target['portCharge'];
                target['finalShippingCost'] = target['freightTotal'] + target['tollFee'] + target['innerShippingFee'] + target['insurance'];
                if(target['dhl']){
                    target['finalShippingCost'] += target['dhl'];
                }
                if(target['other']){
                    target['finalShippingCost'] += target['other'];
                }
                this.shippings = newData;
            }
        },
        handleBankcostChange(value,key,column){
            const newData = [...this.bankcosts];
            const target = newData.find(item => key === item.key);
            if (target) {
                target[column] = value;
                var total = 0;
                this.products.forEach(p=>{
                    total += p.productTotal;
                })

                target["bankFee"] = total - target["actualIncome"];
                target["actualIncomeRMB"] = target["actualIncome"] * target["rate"];
                target["finalIncome"] = target["actualIncomeRMB"] - target["bankFeeRMB"];
                this.bankcosts = newData;
            }
        },
        handleOtherChange(value,key,column){
            const newData = [...this.others];
            const target = newData.find(item => key === item.key);
            if (target) {
                target[column] = value;
               
                this.others = newData;
            }
        },
        handleDateChange(value,key){
            const newData = [...this.bankcosts];
            const target = newData.find(item => key === item.key);
            target['actualIncomeDate'] = value;
            this.bankcosts = newData;
            
        },
        handleProductChange(value, key, column) {
            const newData = [...this.products];
            const target = newData.find(item => key === item.key);
            if (target) {
                target[column] = value;
                target['productTotal'] = target['productPrice'] * target['productCount'];
                this.products = newData;
            }
        },
        handleProductNameChange(e){
            this.selectedProductName = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handlePINoChange(e){
            this.selectedPINo = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleTypeChange(e){
            this.type = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleCountryChange(e){
            this.selectedCountry = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleStatusChange(e){
            this.selectedStatus = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleCustomerChange(e){
            this.selectedCustomer = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        handleFreightChange(e){
            this.selectedFreight = e.target.value;
            this.pageNumber = 1;
            this.loadOrders();
        },
        onETDChange(e){
            this.selectedETD = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        onETAChange(e){
            this.selectedETA = e;
            this.pageNumber = 1;
            this.loadOrders();
        },
        changePageSize(e){
            this.pageSize = parseInt(e);
            window.localStorage.setItem('pageSize',this.pageSize);
            this.pageNumber = 1;
            this.loadOrders();
        },
        resetFilter(){
            this.selectedCountry = "";
            this.selectedETA = [];
            this.selectedETD = [];
            this.selectedType = "";
            this.selectedCustomer = "";
            this.selectedProductName = "";
            this.selectedFreight = "";
            this.pageNumber = 1;
            this.loadOrders();
        },
        loadOrders(){
            var req = {};
            req.start = (this.pageNumber - 1) * this.pageSize;
            req.size = this.pageSize;
            if(this.selectedCountry != ''){
                req.region = this.selectedCountry;
            }
            if(this.selectedType != ''){
                req.type = this.selectedType;
            }
            if(this.selectedPINo != ''){
                req.Pi = this.selectedPINo;
            }
            if(this.selectedETA.length == 2){
                req.eta = [this.selectedETA[0].format('yyyy-MM-DD'), this.selectedETA[1].format('yyyy-MM-DD')];
            }
            if(this.selectedETD.length == 2){
                req.etd = [this.selectedETD[0].format('yyyy-MM-DD'), this.selectedETD[1].format('yyyy-MM-DD')];
            }
            if(this.selectedCustomer != ''){
                req.customer = this.selectedCustomer;
            }
            if(this.selectedFreight != ''){
                req.freight = this.selectedFreight;
            }
            if(this.selectedProductName != ''){
                req.product = this.selectedProductName;
            }
            if(this.selectedStatus != ''){
                req.status = this.selectedStatus;
            }

            this.$http.post(config.url +'/orders',req).then(res=>{
                this.orders = res.data;
                this.summary = res.data.summary;

                this.data = [];
                this.orders.list.forEach( o=>{
                    var obj = {};
                    obj.PiNo = o.PiNo;
                    obj.contractNo = o.contractNo && o.contractNo != null && o.contractNo != '' ? o.contractNo:o.PiNo;
                    obj.customer = o.customer;
                    obj.sales = o.sales;
                    obj.type = o.type;
                    obj.region = o.region;
                    obj.brokerage = o.brokerage;
                    obj.id = o.id;
                    obj.key = o.id;
                    obj.products = o.products;
                    obj.status = o.status ? o.status:'1';
                    obj.others = o.others;
                    obj.shippings = o.shippings;
                    obj.bankcosts = o.bankcosts;
                    obj.procuments = o.procuments;
                    obj.procumentTotal = parseFloat(o.procumentTotal).toFixed(2);
                    obj.profitTotal = parseFloat(o.profitTotal).toFixed(2);
                    obj.shippingTotal = parseFloat(o.shippingTotal).toFixed(2);
                    obj.profitRate = o.profitRate;
                    obj.extraTotal = o.brokerage;
                    obj.otherTotal = o.otherTotal;
                    obj.income = parseFloat(o.income).toFixed(2);
                    obj.brokerageTotal = parseFloat(o.brokerageTotal).toFixed(2);
                    obj.productPrice = parseFloat(o.productPrice).toFixed(2);
                    
                    if(o.eta && o.eta != ''){
                        obj.etaObj = o.eta
                        obj.eta = new Date(o.eta).format('MM.dd');
                    }
                    
                    if(o.etd && o.etd != ''){
                        obj.etdObj = o.etd;
                        obj.etd = new Date(o.etd).format('MM.dd');
                    }

                    this.data.push(obj);
                })
                this.total = this.orders.total;
            })
        },
        edit(row){
            this.mode = 'edit';
            this.form.type = row.type;
            this.form.region = row.region;
            this.form.sales = row.sales;
            if(row.etd && row.etd != ''){
                this.form.etd = moment(row.etdObj);
            }
            else{
                this.form.etd = '';
            }
            if(row.eta && row.eta != ''){
                this.form.eta = moment(row.etaObj);
            }
            else{
                this.form.eta = '';
            }
            this.form.customer = row.customer;
            this.form.PiNo = row.PiNo;
            this.form.id = row.id;
            this.form.status = row.status;
            this.form.brokerage = row.brokerage;
            this.order = row;
            this.products = row.products;
            this.productSummaries = {
                productCount:20,
                productName:'合计',
                productPrice:''
            };

            this.procuments = row.procuments;
            this.shippings = row.shippings;
            if(row.others){
                this.others = row.others;
            }
            else{
                this.others = [];
            }
            this.bankcosts = row.bankcosts;
            var no = row.contractNo && row.contractNo != null && row.contractNo != '' ? row.contractNo:row.PiNo;
            this.form.orderPre = no.substring(0,5);
            this.form.orderPost = row.region + row.customer[0] + row.sales[0];
            this.form.orderNo = no.substring(5).replace(this.form.orderPost, '');
            this.createModal = true;
        },
        addProduct(){
            this.products.push({
                key:this.products.length + 1,
                productCount:1,
                productName:"",
                productPrice:0,
                productTotal:0,
                mode:'edit'
            });

            this.$forceUpdate();
        },
        addProcument(){
            this.procuments.push({
                key:this.procuments.length + 1,
                productCount:1,
                productName:"",
                supplier:"",
                procumentPrice:0,
                procumentRatio:0.115,
                procumentAfterPiao:0,
                procumentTotal:0,
                procumentRefund:0,
                procumentTotalCost:0,
                mode:'edit'
            });

            this.$forceUpdate();
        },
        addShipping(){
            this.shippings.push({
                key:this.shippings.length + 1,
                boxCount:1,
                boxPrice:0,
                boxTotal:0,
                rate:this.form.type == '2'?7:1,
                boxTotalRMB:0,
                portCharge:0,
                freightTotal:0,
                freight:'',
                innerShippingFee:0,
                tollFee:0,
                insurance:0,
                finalShippingCost:0,
                dhl:0,
                other:0,
                mode:'edit'
            });
        },
        addBankcost(){
            this.bankcosts.push({
                key:this.bankcosts.length + 1,
                actualIncome:0,
                actualIncomeDate:'',
                bankFee:0,
                rate:this.form.type == '2'?7:1,
                actualIncomeRMB:0,
                bankFeeRMB:0,
                finalIncome:0,
                mode:'edit'
            });
        },
        addOther(){
            this.others.push({
                feeTitle:'',
                fee:0,
                mode:'edit'
            })
        },
        submitCreateModal(){
            if(this.form.region == '' || this.form.sales == '' || this.form.customer==''){
                this.$message.error('客户名称，国家地区，销售人员为必填项');
                return;
            }

            var postData = {};
            postData.customer = this.form.customer;
            postData.sales = this.form.sales;
            postData.type = this.form.type;
            postData.region = this.form.region;
            postData.etd = this.form.etd;
            postData.eta = this.form.eta;
            postData.products = this.products;
            postData.others = this.others;
            postData.status = this.form.status;
            postData.brokerage = this.form.brokerage;
            postData.procuments = this.procuments;
            postData.bankcosts = this.bankcosts;
            postData.shippings = this.shippings;
            postData.PiNo = this.form.PiNo;
            postData.orderNo = this.form.orderNo;
            postData.contractNo = this.form.orderPre + this.form.orderNo + this.form.orderPost;
            postData.productPrice =0;
            this.products.forEach( p=>{
                postData.productPrice +=p.productTotal;
            })

            postData.income = 0;
            this.bankcosts.forEach(p=>{
                postData.income += p.finalIncome;
            })

            postData.brokerageTotal = 0;
            var calRate = null;
            this.bankcosts.forEach(b=>{
                postData.brokerageTotal += b.bankFee * b.rate + b.bankFeeRMB;
                calRate = b.rate;
            })

            var thisRate = 1;

            if(this.form.type  == 2){
                thisRate = 7.1;
            }

            if(this.bankcosts.length > 0){
                thisRate = parseFloat(this.bankcosts[0].rate);
            }
            postData.shippingTotal = 0;
            this.shippings.forEach(s=>{
                postData.shippingTotal += s.finalShippingCost;
            })

            postData.procumentTotal = 0;
            this.procuments.forEach(p=>{
                postData.procumentTotal += p.procumentTotalCost;
            })

            postData.otherTotal = 0;
            if(this.others && this.others != null){
                this.others.forEach( o =>{
                    postData.otherTotal += o.fee;
                })
            }
            postData.brokerage = 0;
            if(this.form.brokerage && this.form.brokerage != ''){
                postData.brokerage = parseFloat(this.form.brokerage);
            }

            postData.profitTotal = 0;
            if(postData.income != 0){
                postData.profitTotal = postData.income - postData.procumentTotal - postData.shippingTotal - postData.brokerage * thisRate - postData.otherTotal;
            }
            postData.profitRate = 0;

            if(postData.productPrice !=0){
                if(calRate != null){
                    postData.profitRate = (postData.profitTotal*100.0 / (postData.productPrice * calRate)).toFixed(2);
                }
                
            }

            
            if( this.order != null){
                postData.id = this.order.id;
            }
            this.$http.post(config.url +'/order',postData).then(res=>{
                this.createModal = false;
                this.order = null;
                this.loadOrders();
            })
        },
        createOrder(){
            this.mode = 'create';
            this.form.type = '2';
            this.form.orderNo = '';
            this.form.orderPre = '';
            this.form.orderPost = '';
            this.form.region = '';
            this.form.sales = '';
            this.form.etd = '';
            this.form.eta = '';
            this.form.status = '1';
            this.form.customer = '';
            this.form.PiNo = '';
            this.form.brokerage = '';
            this.products = [];
            this.procuments = [];
            this.shippings = [];
            this.bankcosts = [];
            this.others = [];
            this.order = {};
            this.createModal = true;
        }
    }
  };
  </script>
  
  <style>
.ant-calendar-cell{
    min-width: initial !important;
}

.ant-form-item{
    margin-bottom:0px !important;
}

.ant-tabs-tabpane .ant-table-column-title{
    font-size:13px !important;
}

.ant-table-tbody > tr > td{
    padding:10px 2px !important;
}

.order-header .ant-select-selection-selected-value{
    color:#666 !important;
    font-size:13px !important;
}
.ant-empty-normal .ant-empty-image{
    display:none !important;
}

.ant-empty-normal{
    margin:10px 0px !important;
}

.ant-modal{
    top:60px !important;
}

.total-item{
    margin:0px 10px;
}

.total-item .num{
    color:#1890ff;
}
</style>


// WEBPACK FOOTER //
// orders.vue?1c3460aa